export const colors = {
    primary: '#80c9ca',
    secondary:  '#3eb6ad',
    white: '#fff',
    orange: '#f27046'
}